import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_STATE,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormFields(fields) {
  return {
    type: RESET_FORM_STATE,
    payload: { fields },
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TripInterruption/actions.js